module.exports = __webpack_public_path__ + "img/schiariture.4f063834.png";